import { HttpErrorResponse } from '@angular/common/http';

import { userFacingRejection } from '@core/http-interceptors/user-facing-rejection';

/**
 * The text a caught value can show the user — never empty, so a failure always reads as one.
 * - a string as it is;
 * - an `HttpErrorResponse`: the API's user-facing reason, otherwise the fallback (its `message` is
 *   English and carries the request URL, so it is never shown);
 * - otherwise an `Error`'s `message`, or the fallback.
 */
export function errorMessage(error: unknown, fallback = 'Ukendt fejl'): string {
  if (typeof error === 'string') return error || fallback;
  if (error instanceof HttpErrorResponse) return userFacingRejection(error) ?? fallback;
  const message = (error as { message?: unknown } | null | undefined)?.message;
  return typeof message === 'string' && message ? message : fallback;
}
